(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crown-landing"] && !Shopify.designMode) return;
  try {
    
function initCrownCampaign(root){
 if(root.dataset.initialized)return;
 root.dataset.initialized='true';
 const form=root.querySelector('form'),select=root.querySelector('[data-crown-variant]'),button=root.querySelector('[data-crown-buy]');
 const variants=JSON.parse(root.querySelector('[data-crown-variants]').textContent);
 const ready=root.dataset.crownSales==='true',groups=[...root.querySelectorAll('[data-crown-option]')];
 const format=value=>new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(value/100);
 const label=(v)=>root.dataset.labelTemplate.replace('[units]',v.options[0].split(' ')[0]).replace('[price]',format(v.price));
 function update(){
  const options=groups.map(g=>g.querySelector('input:checked')?.value);
  const variant=variants.find(v=>v.options.every((o,i)=>o===options[i]));
  if(variant&&select.value!==String(variant.id)){select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
  const canBuy=Boolean(ready&&variant?.available&&variant.price>0);
  button.disabled=!canBuy;
  button.textContent=!ready?root.dataset.pendingLabel:canBuy?root.dataset.buyLabel:root.dataset.unavailableLabel;
  root.querySelector('[data-crown-price]').textContent=variant?'$ '+format(variant.price)+' COP':root.dataset.unavailableLabel;
  root.querySelector('[data-crown-selection]').textContent=variant?root.dataset.selectionLabel.replace('[pack]',variant.options[0].split(' ')[0]).replace('[size]',variant.options[1]):'';
  groups[0].querySelectorAll('label').forEach(el=>{const value=el.querySelector('input').value,v=variants.find(v=>v.options[0]===value&&v.options[1]===options[1]);if(v)el.querySelector('[data-crown-choice-label]').textContent=label(v);});
  document.querySelectorAll('[data-crown-pack-link]').forEach(el=>{const value=el.dataset.crownPackLink,v=variants.find(v=>v.options[0]===value&&v.options[1]===options[1]);if(v)el.querySelector('[data-crown-pack-text]').textContent=label(v);});
 }
 root.querySelector('.crown-enhanced').hidden=false;
 root.querySelector('.crown-fallback').hidden=true;
 form.addEventListener('change',e=>{if(e.target===select){const v=variants.find(v=>String(v.id)===select.value);if(v)groups.forEach((g,i)=>g.querySelectorAll('input').forEach(r=>r.checked=r.value===v.options[i]));}update();});
 form.addEventListener('submit',e=>e.preventDefault());
 button.addEventListener('click',e=>{update();if(button.disabled){e.preventDefault();e.stopImmediatePropagation();return;}window.ES_CLOSEST_FORM=form;},true);
 root.addEventListener('click',e=>{if(!ready&&e.target.closest('.es-popup-button')){e.preventDefault();e.stopImmediatePropagation();}},true);
 document.querySelectorAll('[data-crown-pack-link]').forEach(el=>el.addEventListener('click',()=>{groups[0].querySelectorAll('input').forEach(r=>r.checked=r.value===el.dataset.crownPackLink);update();}));
 update();
}
document.querySelectorAll('[data-crown-root]').forEach(initCrownCampaign);
document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('[data-crown-root]').forEach(initCrownCampaign);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
